import type { Language } from '../i18n/translations';
import { formatDate } from './format';

const USAGE_CREDITS_INSUFFICIENT = 'USAGE_CREDITS_INSUFFICIENT';

const DATE_LOCALES: Record<Language, string> = {
  en: 'en-US',
  es: 'es',
  pt: 'pt-BR',
};

type Translate = (key: string, params?: Record<string, string | number>) => string;

function refusalBody(error: unknown): { code?: string; renewsAt?: string } | undefined {
  return (error as { response?: { data?: { code?: string; renewsAt?: string } } } | null)?.response
    ?.data;
}

export function isCreditsRefusal(error: unknown): boolean {
  return refusalBody(error)?.code === USAGE_CREDITS_INSUFFICIENT;
}

export function creditsRefusalMessage(error: unknown, t: Translate, language: Language): string {
  const renewsAt = refusalBody(error)?.renewsAt;
  const renewal = renewsAt ? new Date(renewsAt) : null;

  if (renewal && !Number.isNaN(renewal.getTime())) {
    return t('common.creditsExhausted', {
      date: formatDate(renewal, DATE_LOCALES[language]),
    });
  }

  return t('common.creditsExhaustedNoDate');
}
